import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  data: {},
  // error: {},
})

const { Types, Creators } = createActions({
  getInvoice: null,
  setInvoice: ['data'],
  // getItemOptionsError: ['error'],
  // getItemOptionsDisconnected: null,
})

export const getInvoiceReducer = state => state
export const setInvoiceReducer = (state, { data }) => state.set('data', data)

// export const getItemOptionsConnectedReducer = (state, { itemOptions, storeId }) =>
//   state.setIn(['data', storeId], itemOptions).set('loading', false)

// export const getItemOptionsDisconnectedReducer = state => state.set('loading', false)

// export const getItemOptionsErrorReducer = (state, { error }) =>
//   state.set('error', error).set('loading', false)

export const invoiceReducer = createReducer(INITIAL_STATE, {
  [Types.GET_INVOICE]: getInvoiceReducer,
  [Types.SET_INVOICE]: setInvoiceReducer,
  // [Types.GET_ITEM_OPTIONS_DISCONNECTED]: getItemOptionsDisconnectedReducer,
  // [Types.GET_ITEM_OPTIONS_ERROR]: getItemOptionsErrorReducer,
})

export const InvoiceTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/invoiceReducer.js